









import { Component, Prop, Vue } from 'vue-property-decorator'
import { Pipeline } from '@/api/model/pipeline'
import { namespace } from 'vuex-class'
const referrals = namespace('referrals')

@Component
export default class PipelineLabel extends Vue {
    @referrals.Getter('selectablePipelines') readonly pipelines!: Pipeline[]
    @referrals.State('outgoingPipelines') readonly outgoingPipelines!: Pipeline[]
    @Prop({ required: true }) readonly pipeline!: Pipeline

    getPipeline(id: string): Pipeline | undefined {
        // Connected pipelines of other companies are only selectable when looking at outgoing leads
        return this.pipelines.find(v => v.id === id) || this.outgoingPipelines.find(v => v.id === id)
    }

    isExternalPipeline(id: string): boolean {
        // A lead's pipeline can be missing from the store (not loaded yet, e.g. on the dashboard); show just its name then
        const pipeline = this.getPipeline(id)

        return !!pipeline && pipeline.isExternal(this.$currentCompany)
    }
}
